export default "__VITE_ASSET__60b8a576__"